import React, { useState } from 'react';
import { Tabs, Tab, TextField,Box } from '@mui/material';
import LanguageConfig from './LanguageConfig';
import General from './General';
import { useSearchParams } from 'react-router-dom';



const BotConfig = () => {
  const [searchParams] = useSearchParams();
  const botId = searchParams.get("botid");
  const bots_type = searchParams.get("bots_type");
  const [tabValue, setTabValue] = useState('general');
 


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="Bot Configuration Tabs">
        <Tab label="General" value="general" />
        <Tab label="Languages" value="languages" />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ mt: 2 }}>
        {tabValue === 'languages' && (
          <LanguageConfig botId={botId} bots_type={bots_type}/>
        )}

        {tabValue === 'general' && (
         <General botId={botId} bots_type={bots_type}/>
        )}
      </Box>
    </Box>
  );
};

export default BotConfig;
